/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientImmunizationsViewModel } from './PatientImmunizationsViewModel'; 

export function getImmunizationsOptions(stayId: string, onSuccess?: (result: PatientImmunizationsViewModel) => void) {
	return queryOptions({
		queryKey: ['immunizations', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/demographics/immunizations/queries/getimmunizations/' + stayId;
			const resp = await axios.get<PatientImmunizationsViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}